<header>
  <div class="header-content">
    <span class="hamburger" (click)="toggleNav()">&#9776;</span>
    <div class="d-flex justify-content-between w-100">
      <div class="header-breadcrumb">
        <h1 class="d-block">R<span class="d-none d-md-inline">ecord </span>R<span class="d-none d-md-inline">etrieval</span> Client Portal</h1>
        <h2>{{ breadcrumbPath[0].label }}</h2>
      </div>
      <div class="right-section d-flex align-items-stretch justify-content-end">
        <!-- Full search input for desktop -->
        <div class="search-input-group d-flex-x align-items-center-x">
          <p-inputgroup>
            <input
              pInputText
              id="landing-page-order-number"
              placeholder="Search by order number"
              #searchInput
              (keyup.enter)="searchClicked(searchInput.value)"
            />
            <p-inputgroup-addon class="global-search justify-content-center">
              <p-button
                icon="pi pi-search"
                aria-label="Search"
                variant="text"
                (click)="searchClicked(searchInput.value)"
              >
                <label class="visually-hidden">Search</label>
              </p-button>
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>

        <!-- Popover trigger for mobile -->
        <div class="search-icon-trigger">
          <p-button
            icon="pi pi-search"
            aria-label="Open Search"
            (click)="searchPopover.toggle($event)"
            variant="text"
          ></p-button>

          <p-popover #searchPopover appendTo="body">
            <div class="p-2 d-flex">
              <input
                pInputText
                placeholder="Search by order number"
                type="text"
                #mobileSearchInput
                (keyup.enter)="searchClicked(mobileSearchInput.value); searchPopover.hide()"
              />
              <p-button
                label="Search"
                (click)="searchClicked(mobileSearchInput.value); searchPopover.hide()"
                class="ms-2"
              ></p-button>
            </div>
          </p-popover>
        </div>

        <!-- Profile Dropdown Trigger --> 
        <div
          id="user-profile-dropdown"
          class="profile-container"
          tabindex="0"
          role="button"
          aria-haspopup="true"
          [attr.aria-expanded]="profileDropdownOpen"
          aria-controls="profile-dropdown"
          (click)="toggleProfileDropdown($event)"
          (keydown.enter)="toggleProfileDropdown($event)"
        >
          <i alt="Profile Icon" class="pt-1 fa fa-user"></i>
          <div class="profile-info">
            <div class="d-flex flex-column">
              <span class="profile-name">{{ firstName || displayName }} {{ lastName }}</span>
              <div class="d-flex flex-row gap-0 align-items-center profile-designation">
                <span>{{ accountname }}</span>
                @if(internalUser || (!internalUser && (availableTenants?.length ?? 0) > 1)){
                  <i *ngIf="accountname" class="pi pi-angle-right" style="color: #fff"></i>
                  <span class="">{{ selectedTenant }}</span>
                }
              </div>
            </div>
            <span class="fa fa-caret-down"></span>
          </div>
        </div>

        <!-- Popover Dropdown Content -->
        <p-popover styleClass="user-profile" #op>
          <ul id="profile-dropdown" class="dropdown-menu-list" role="menu">
            <li>
              <a
                id="profile-dropdown-carrier-name"
                #dropdownItem
                class="dropdown-items"
                tabindex="-1"
                (keydown)="onDropdownItemKeyDown($event, 0)"
              >
                <i class="pi pi-briefcase me-2"></i> Tenant
              </a>
              <ul>
                <li *ngFor="let tenant of availableTenants; let i = index">
                  <a
                    id="profile-dropdown-tenant-{{ i + 1 }}"
                    class="dropdown-items"
                    tabindex="-1"
                    #dropdownItem
                    (keydown)="onDropdownItemKeyDown($event, i + 1)"
                    (click)="changeTenant(tenant)"
                  >
                    {{ tenant }}
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a
                id="logout"
                tabindex="-1"
                #dropdownItem
                class="dropdown-items d-flex align-items-center"
                (keydown)="onDropdownItemKeyDown($event, (availableTenants?.length || 0) + 1)"
                (click)="logout()"
              >
                <i class="pi pi-sign-out me-2"></i> Logout
              </a>
            </li>
          </ul>
        </p-popover>

        <!-- Place Order Button -->
        <div class="d-flex align-items-center px-2">
          <button id="place-order" class="btn btn-primary mx-2" #placeOrderBtn (click)="loadOrderInfoComponent()">Place Order</button>
        </div>
      </div>
    </div>
  </div>
</header>
